import type { ReactNode } from 'react';

import { clickActionsAttributes } from '#/snippets/click-actions.attributes';

import { DropdownMenuItemLi } from './DropdownMenuItem.styled';

type Props = {
  children: ReactNode;
  mobileOnly?: boolean;
  qaId?: string;
};

export function DropdownMenuItem({ children, mobileOnly, qaId }: Props) {
  return (
    <DropdownMenuItemLi
      $mobileOnly={mobileOnly}
      data-qa-id={qaId}
      // oxlint-disable-next-line react/jsx-props-no-spreading
      {...clickActionsAttributes({
        closeRichDetailsFromWithin: true,
      })}
    >
      {children}
    </DropdownMenuItemLi>
  );
}
